import { Schema } from '../../../Entities/Schema.entity';
import { createSchema } from '../../../Utils/CreateSchema';

export const reservationSubmitPaidSchema: Schema = {
  ...createSchema({
    version: '1-0-0',
    description: 'Submission of a reserve lead',
    name: 'reserve_submit_paid',
    properties: {
      lead_type: {
        type: 'string',
        description: 'The type of lead',
      },
      stripe_register_id: {
        type: 'string',
        description: 'the register id from stripe',
      },
      listing_id: {
        type: 'string',
        description: 'The id of the listing',
      },
    },
    required: ['lead_type', 'stripe_register_id', 'listing_id'],
  }),
};
